class ItemComponents extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger () {
    const isOpen = this.getAttribute('aria-expanded') === 'true'
    const contentEl = this.querySelector(this.els?.items?.selector)

    if (!contentEl) return

    if (isOpen) {
      const currentHeight = contentEl.scrollHeight
      contentEl.style.maxHeight = `${currentHeight}px`
      requestAnimationFrame(() => {
        contentEl.style.maxHeight = '0px'
      })
      this.setAttribute('aria-expanded', 'false')
    } else {
      const fullHeight = contentEl.scrollHeight
      contentEl.style.maxHeight = `${fullHeight}px`
      this.setAttribute('aria-expanded', 'true')
    }
  }
}

if (!customElements.get('item-components')) {
  customElements.define('item-components', ItemComponents)
}
